import React from 'react'

import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

import { ILargeTestimonial as IContentfulLargeTestimonial } from 'marketing-site/@types/generated/contentful'
import {
  IProps as ILargeTestimonial,
  Testimonial,
} from 'marketing-site/src/library/components/Testimonial'

import { transformCTALink } from 'marketing-site/src/transformers/elements/ContentfulCTALink'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import * as Utils from 'marketing-site/src/library/utils'
import { transformImage } from '../elements/ContentfulImage'

export const ContentfulLargeTestimonial = (testimonial: IContentfulLargeTestimonial) => (
  <EntryMarker entry={testimonial}>
    {() => <Testimonial {...transformLargeTestimonial(testimonial)} />}
  </EntryMarker>
)

export function transformLargeTestimonial({
  fields,
}: IContentfulLargeTestimonial): ILargeTestimonial {
  return {
    ...fields,
    bgColor: Utils.getHexColorFromName(fields.bgColor),
    companyLogo: fields.companyLogo ? fields.companyLogo.fields.file.url : undefined,
    cta: fields.cta && transformCTALink(fields.cta),
    portraitImgRef: transformImage(fields.portraitImgRef),
    productText: fields.productRichText && documentToHtmlString(fields.productRichText),
    quote: documentToHtmlString(fields.quoteRichText),
    roundedBorders: fields.roundedBorders || false,
  }
}
